import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

// Solid
import {
  faUser,
  faBan,
  faCamera,
  faClock,
  faHourglassEnd,
  faInbox,
  faTasks,
  faPen,
  faLink,
  faGlobe,
  faChevronLeft,
  faChevronRight,
  faCheckCircle,
  faTimesCircle,
  faCircle as fasCircle,
  faRedoAlt,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faSearchPlus,
  faImage,
  faCalendarDay,
  faBuilding,
  faSitemap,
  faAddressCard,
  faEnvelope,
  faPhone,
  faMobile,
  faExclamationCircle,
  faExclamationTriangle,
  faEdit,
  faDownload,
  faEye,
  faTrashAlt,
  faCheck,
  faTimes,
  faPlus,
  faMinus,
  faToggleOn,
  faToggleOff,
  faFileCsv,
  faFileArchive,
  faUserSlash,
} from '@fortawesome/pro-regular-svg-icons';

// Light
import {
  faEllipsisV,
  faFileAlt,
  faMap,
  faCircle,
  faArrowRight,
  faPlusCircle,
  faPaste,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  // Solid
  faUser,
  faBan,
  faCamera,
  faClock,
  faHourglassEnd,
  faInbox,
  faTasks,
  faPen,
  faChevronLeft,
  faChevronRight,
  faCheckCircle,
  faTimesCircle,
  fasCircle,
  faRedoAlt,
  faSearchPlus,
  faImage,
  faCalendarDay,
  faBuilding,
  faLink,
  faGlobe,
  faSitemap,
  faAddressCard,
  faEnvelope,
  faPhone,
  faMobile,
  faExclamationCircle,
  faExclamationTriangle,
  faEdit,
  faDownload,
  faEye,
  faTrashAlt,
  faCheck,
  faTimes,
  faPlus,
  faMinus,
  faToggleOn,
  faToggleOff,
  faFileCsv,
  faFileArchive,
  faEllipsisV,
  faFileAlt,
  faMap,
  faCircle,
  faArrowRight,
  faPaste,
  faPlusCircle,
  faUserSlash
);

export { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText };
